import * as React from 'react';
import propz from 'propz';
import { Autocomplete } from 'Src/components/Autocomplete/Autocomplete';
import { getNameByPlaceOrPostcode } from 'Src/helpers/autocomplete/autocomplete';
import { Map } from 'Src/components/Map/Map';
import { ClubWizardErrors } from '../ClubWizard';
import { Sport } from '../../../../../../../models/sport';
import { ClubSport } from '../../../../../../../models/club';
import { MultiSelectCheckboxItem } from '../../../../../../../components/MultiSelectCheckboxes/MultiSelectCheckboxes';
import '../ClubWizard.scss';

interface Props {
  location: string;
  onInputChange: (event) => void;
  getVenues: (text: string) => any;
  onVenueSelect: (venue: any) => void;
  venue: any;
  createVenueFormOpen: () => void;
  errors: ClubWizardErrors;
  name: string;
  sport: Sport | ClubSport;
  genderItems: MultiSelectCheckboxItem[];
  ageItems: MultiSelectCheckboxItem[];
}

export function ClubWizardVenueStep(props: Props) {
  const { location, onInputChange, getVenues, venue, onVenueSelect, createVenueFormOpen, errors } = props;
  const point = propz.get(venue, ['point']);
  return (
    <div className="clubWizardDsStep">
      <section className="clubWizardDsSection">
        <div className="clubWizardDsSection__head">
          <span className="clubWizardDsSection__icon">1</span>
          <div>
            <h3>Location</h3>
            <p>Choose the venue and add any room, pitch or meeting-point note.</p>
          </div>
        </div>

        <div className="clubWizardDsVenueRow">
          <label className="clubWizardDsField">
            <span>
              Venue / postcode <i className="clubWizardDsRequired">*</i>
            </span>
            <div className="clubWizardDsAutocomplete">
              <Autocomplete
                searchFunction={getVenues}
                getElementTitle={getNameByPlaceOrPostcode}
                customClass="mFullWidth"
                placeholder="Start typing the venue name"
                defaultItem={venue}
                onSelect={onVenueSelect}
              />
            </div>
            {errors.venue && <em>Required</em>}
          </label>

          <button type="button" className="clubWizardDsVenueLink" onClick={createVenueFormOpen}>
            + Create venue
          </button>
        </div>

        <div className="clubWizardDsMapCard">
          <div>
            <strong>Map</strong>
            <span>Selected venue location preview.</span>
          </div>
          <Map point={point} customStylingClass="eClubWizardMap" isMarkerDraggable={false} />
        </div>

        <label className="clubWizardDsField clubWizardDsField--specificLocation">
          <span>Specific location</span>
          <input
            type="text"
            onChange={onInputChange}
            value={location}
            name="location"
            placeholder="e.g. Meet by the changing rooms"
          />
        </label>
      </section>
    </div>
  );
}
